var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 180,
    viewBox: "0 0 263 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 262.5,
    height: 180,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.75 91V63H137.75M137.75 63V79H153.75M137.75 63L153.75 79M153.75 79V91",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.45 113L106.75 99H109.49L112.01 110.14L114.97 99H117.79L120.67 110.14L123.19 99H125.95L122.15 113H119.11L116.33 102.62L113.47 113H110.45ZM133.805 113V99H142.945V101.06H136.365V104.9H142.345V106.9H136.365V110.94H142.945V113H133.805ZM151.368 113V99H156.988C158.441 99 159.548 99.34 160.308 100.02C161.081 100.687 161.468 101.547 161.468 102.6C161.468 103.48 161.228 104.187 160.748 104.72C160.281 105.24 159.708 105.593 159.028 105.78C159.828 105.94 160.488 106.34 161.008 106.98C161.528 107.607 161.788 108.34 161.788 109.18C161.788 110.287 161.388 111.2 160.588 111.92C159.788 112.64 158.654 113 157.188 113H151.368ZM153.928 104.88H156.608C157.328 104.88 157.881 104.713 158.268 104.38C158.654 104.047 158.848 103.573 158.848 102.96C158.848 102.373 158.654 101.913 158.268 101.58C157.894 101.233 157.328 101.06 156.568 101.06H153.928V104.88ZM153.928 110.92H156.788C157.548 110.92 158.134 110.747 158.548 110.4C158.974 110.04 159.188 109.54 159.188 108.9C159.188 108.247 158.968 107.733 158.528 107.36C158.088 106.987 157.494 106.8 156.748 106.8H153.928V110.92Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.53be7af90919882e2840f935ab8e6be3.svg";
export { ForwardRef as ReactComponent };